import content from '../../../locales/en/content.json';
import signerRole from './signerRole';
import supportingDocs from './supportingDocs';

const roleIsRep = formData => formData.signAsRepresentativeYesNo === 'yes';

export const signerPages = {
  signerRole: {
    path: 'application-signature/next-steps',
    title: content['sign-as-rep-title--review'],
    ...signerRole,
  },
  signerSupportingDocs: {
    path: 'application-signature/upload-supporting-document',
    title: content['sign-as-rep-title--upload'],
    depends: roleIsRep,
    ...supportingDocs,
  },
};
